import { useEffect, useState } from 'react';
import { setPeriodicity as updatePeriodicity } from '../api/api';
import { connect } from 'react-redux';

window.onPeriodicityChange = (productId, periodicity) => {
  const evt = new CustomEvent('product-periodicity-changed', {
    detail: {
      productId,
      periodicity,
    },
  });
  document.dispatchEvent(evt);
};

const PeriodicityPill = ({ product, customer }) => {
  const [periodicity, setPeriodicity] = useState(product.periodicity);
  const [loading, setLoading] = useState(false);
  const pagePath = window.location.pathname;
  const setNewPeriocity = (newPeriodicity) => {
    if (newPeriodicity === periodicity || loading) {
      return;
    }

    setLoading(true);
    let { id, is_sweet, is_snack, is_breakfast, is_fruit } = product;
    window.shouldReshuffle = true;

    updatePeriodicity(id, newPeriodicity)
      .then(() => {
        setPeriodicity(newPeriodicity);
        setLoading(false);
        if (pagePath.includes('delivered')) {
          let data = {
            event: 'hr.sku_rating.set',
            sku_id: id,
            rating: newPeriodicity,
            is_breakfast: is_breakfast,
            is_snack: is_snack,
            is_sweet: is_sweet,
            is_fruit: is_fruit,
          };
          if (customer) {
            data = Object.assign({}, data, {
              num_lunch: customer.pricing_config.num_lunch,
              num_dinner: customer.pricing_config.num_dinner,
              packs_breakfast: customer.pricing_config.packs_breakfast,
              packs_snack: customer.pricing_config.packs_snack,
              packs_sweets: customer.pricing_config.packs_sweets,
              packs_fruit: customer.pricing_config.packs_fruit,
            });
          }
          dataLayer.push(data);
        }

        typeof onPeriodicityChange === 'function' &&
          onPeriodicityChange(id, newPeriodicity);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    const onProductPeriodicityChanged = (evt) => {
      const { productId, periodicity } = evt.detail;
      if (productId !== product.id) {
        return;
      }
      setPeriodicity(periodicity);
    };

    document.addEventListener(
      'product-periodicity-changed',
      onProductPeriodicityChanged
    );

    return () =>
      document.removeEventListener(
        'product-periodicity-changed',
        onProductPeriodicityChanged
      );
  }, []);

  return (
    <div className={'periodicity-pill'}>
      <div
        onClick={() => setNewPeriocity(3)}
        data-testid={`periodicity-pill-${product.id}-often`}
        className={
          'periodicityBtn hr-bold' +
          (periodicity && periodicity === 3 ? ' selected' : '')
        }
      >
        OFTEN
      </div>
      <div
        onClick={() => setNewPeriocity(2)}
        data-testid={`periodicity-pill-${product.id}-sometimes`}
        className={
          'periodicityBtn hr-bold' +
          (periodicity && periodicity === 2 ? ' selected' : '')
        }
      >
        SOMETIMES
      </div>
      <div
        onClick={() => setNewPeriocity(1)}
        data-testid={`periodicity-pill-${product.id}-never`}
        className={
          'periodicityBtn hr-bold' +
          (periodicity && periodicity === 1 ? ' selected' : '')
        }
      >
        NEVER
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    customer: state.customer,
  };
};

export default connect(mapStateToProps, null)(PeriodicityPill);
